import { cloneDeep, every, find, flatMap, flatMapDeep, forOwn, get, groupBy, isEmpty, isNumber, isObject, round, some, toPairs, uniq } from 'lodash';
import store from '@/store';
import BimPlus from '@/models/BimPlus';
import Forge from '@/models/Forge';
import { v4 as uuid } from 'uuid';
import urls from '@/urls';
//const store = require('../../store');
const WebSDK = require('bimplus-websdk');
const WebClient = require('bimplus-webclient');
const Renderer = require('bimplus-renderer');

//await store.restored;
//const accessToken = store.state.bimplus.access_token;

let environment = urls.bimplusEnvironment;

//Initalize api wrapper
let config = WebSDK.createDefaultConfig(environment);
config.cache = true;

let api = new WebSDK.Api(config);
let objectProperties = null;
let viewport3D = null;
let viewer = null;
let teamslug = null;
let projectId = null;

let createViewport = () => {
    let settings = {
      defaultOpacity: 0.5,
      disciplineOpacity: 0.1,
      pinSizeScaleFactor: 2,
      maxWebGLBufferSize: 350e12,
      mixedModelMode: true,
      pinFlyToDistance: 20000,
      nearClippingPlane: 0.01,
      slideThmbSize: [180, 112],
      useFrameSelection: true,
    };

    let units = {
      weight: {
        multiplicator: 0.001,
        unit: "kg",
      },
      length: {
        multiplicator: 0.001,
        unit: "m",
      },
      width: {
        multiplicator: 0.001,
        unit: "m",
      },
      height: {
        multiplicator: 0.001,
        unit: "m",
      },
      area: {
        multiplicator: 0.000001,
        unit: "m²",
      },
      volume: {
        multiplicator: 1e-9,
        unit: "m³",
      },
    };

    const newviewport = new Renderer.Viewport3D({
      settings: settings,
      units: units,
      domElementId: "maninViewportContainer",
      name: "mainRendererViewport",
      GPUPick: true
    });
    return newviewport;
};

let setgeneralSettings = () => {
    let viewportOcclusionOptions = viewport3D.getAmbientOcclusionOptions();
    viewport3D.setAmbientOcclusionOptions(viewportOcclusionOptions);
    
    viewport3D.setBackground(2, {
      alpha: 1.0,
      colorStops: [
        { offset: 0.0, color: "#87CEEB"},
        { offset: 1.0, color: "#FFFFFF"}
      ]
    });
};

let registerEventListener = (disableObjectProperties, data) => {
  $(viewport3D.domElement).on("select3DObject", function(e, param) {
    let selectedObject =
        viewport3D.objectSets.selectedObjects.length > 0
          ? viewport3D.objectSets.selectedObjects[
              viewport3D.objectSets.selectedObjects.length - 1
            ]
          : undefined;
    if(!disableObjectProperties) {
      if(selectedObject?.id) {
        objectProperties.load(teamslug, projectId, selectedObject.id );
        $("#objectProperties").fadeIn();
      } else {
        $("#objectProperties").fadeOut();
      }
    } else {
      if(selectedObject?.id) {
        data.enableAddObjects = true;
      } else {
        data.enableAddObjects = false;
      }
      
    }
  });
};

let removeUnwantedElements = (elements) => {
  return elements.filter(x => {
    const type = x?.type?.toLowerCase();
    return type !== 'weld' && type !== 'jointopening'
  });
};

let hasMfactProperty = (element) => {
  return some(element, (value, key) => {
    if(isObject(value)) {
      return hasMfactProperty(value);
    }
    return value != null && value !== '' && key.toLowerCase() === 'manufacton item id';
  });
};

let getMfactElements = (elements) => {
  return elements.filter(el => hasMfactProperty(el.attributes));
};

let collectMfactItemIds = (attributes) => {
  let itemIds = [];

  forOwn(attributes, (value, key) => {
    if(isObject(value)) {
      itemIds = itemIds.concat(collectMfactItemIds(value));
    } else if (key.toLowerCase() === 'mfact_itemid' && value != null && value != '') {
      itemIds.push(value);
    }
  });

  return itemIds;
};

let getMfactItemIds = (elements) => {
  return uniq(flatMap(elements, el => collectMfactItemIds(el.attributes)));
};

let findProperty = (obj, key) => {
  if (obj == null || typeof obj !== "object") return undefined;

  if (obj.hasOwnProperty(key)) {
    const val = obj[key];
    if (val === "" || val === null || val === undefined) {
      return undefined;
    }
    return val;
  }

  for (const k in obj) {
    const value = findProperty(obj[k], key);
    if (value !== undefined) return value;
  }

  return undefined;
}

export default{
  async LoadViewer(teamSlug, projectid, disableObjectProperties, data) {
    const accessToken = store.state.bimplus.access_token;
    if(api !== null) api.setAccessToken(accessToken);

    let externalClient = new WebClient.ExternalClient("MyClient");

    objectProperties = new WebClient.BimObjectProperties(
      "bimplusObjectProperties",
      api.getAccessToken(),
      externalClient,
      environment
    );
    
    if(teamSlug) {
      api?.setTeamSlug(teamSlug);
      teamslug = teamSlug;
      projectId = projectid;
    } 
    viewport3D = createViewport();
    viewport3D.setViewportSize();
    registerEventListener(disableObjectProperties, data);
    setgeneralSettings();

    viewer = new Renderer.ProjectViewer(api, viewport3D);

  },
  async getProjectModels(projectId) {
    let project = await viewer.loadProject(projectId);
    let models = await project.getModels();
    return models;
  },
  async showModel(projectID, model) {
    try {
      model.setCurrentRevision(model.getLatestRevision());
      await viewer.loadModelStructure(model);
      let mvs = viewer.getModelViewState(model.id);
      mvs.setLayersVisible(true);
      mvs.setLeafNodesVisible(true);
      await viewer.setModelViewState(mvs);    
    } catch(err) {
      console.log(err);
    }
  },
  
  // #region Element Details
  async getElementDetails(divisionTopologyId, access_token, team_slug) {
    let accessToken = access_token || api.getAccessToken();
    let teamSlug = team_slug || api.getTeamSlug()
    
    const params = {
      access_token: accessToken,
      teamSlug: teamSlug,
      topologyId: divisionTopologyId
    };
    
    const elementProperties = await BimPlus.getElementDetails(params);

    return removeUnwantedElements(elementProperties.flat());
  },

  // #endregion

  // #region Set Camera position

  // Reset the current view and camera state
  resetView() {
    viewport3D.resetSelectionMode();
    viewport3D.restoreViewbox();
    viewport3D.setRotationCenter(null);
    $("#objectProperties").fadeOut();
  },
 
  // Set camera to front view
  frontView() {
    viewport3D.setCameraResetAxis("x");
  },

  // Set camera to top view
  topView() {
    viewport3D.setCameraResetAxis("y");
  },

  // Set camera to side view
  sideView() {
    viewport3D.setCameraResetAxis("z");
  },

  // Set camera to pespective view
  perspectiveView() {
    viewport3D.setCameraResetAxis("xyz");
  },
  // #endregion

  // #region Isolate Objects
  isolateObjects(guids) {
    viewport3D.isolateObjects(guids);
    viewport3D.zoomToObjects(guids);
  },

  isolateHide(guids) {
    this.isolateObjects(guids);
    viewport3D.setSelectionMode("hideIsolated");
  },

  // #endregion
  
  // #region Filter Model
  async filterModels(projectId, model) {
    let itemsInViewer = viewport3D.getObjectsContainer().getObjectsArray();
    let elementProperties = await this.getElementDetails(model);
    let elementsToFilter = removeUnwantedElements(elementProperties);
    let mfactElements = getMfactElements(elementsToFilter);
    let mfactElementIds = mfactElements.map(el => el.id);
    let mfactItemIds = getMfactItemIds(mfactElements);
    //let mfactElementIds = ['0a631a40-9671-4e01-ba0a-44f46d806584', '9f72f01f-7831-4945-87d9-84c0aa9f96c3', 'd0f16ca7-df58-4427-b7a6-070d4eab65fe'];
    //this.isolateObjects(mfactElementIds);
    viewport3D.colorizeObjects(mfactElementIds, "rgb(0,128,0)");
    viewport3D.draw();

    const queryParams = {
      projectId: projectId,
      search: store.state.queryParams.searchText,
      showPrivate: true,
    };
    queryParams.itemIds = mfactItemIds;
    queryParams.lmv = true;
    queryParams.limit = 1000;

    const dBData = await Forge.getItemStatus(queryParams);
  },
  // #endregion

  // #region Update Stage
  async updateManufactonProperty(projectId, guids) {
    let accessToken = api.getAccessToken();
    let teamSlug = api.getTeamSlug();
    
    const params = {
      access_token: accessToken,
      bimTeamslug: teamSlug,
      guids: guids,
      bimProjectId: projectId
    };
    const mfactProperties = await BimPlus.setManufactonProperties(params);

  },

  async getModelSource(modelId) {
    let objectAttributes = await api.objects.get(modelId);
    const sourceApplication = get(
                    find(flatMapDeep(objectAttributes, toPairs), ([k]) => k === "source application"),
                      1);
    return sourceApplication === 8 ? 'SDS2' : 'Others';
  },

  async groupOrders(params) {
    const { elementsData, orderGroupingProperty, isSDS2, selectedProject, materialData, modelId, owner, itemGroupingProperty, itemGroupingType } = params;
    let groupingPath;
    let creationData = [];
    let groupedData;
    let isManufactonLinked;
    groupingPath = Object.keys(elementsData[0].attributes).filter((key) => {
      let orderPath = find([elementsData[0].attributes[key]], orderGroupingProperty)
      if (orderPath) return key;
    })
    if (isEmpty(groupingPath)) return {creationData: {}, groupedData: {}};
    groupedData = groupBy(elementsData, `attributes.${groupingPath[0]}.${orderGroupingProperty}`)
    groupedData = Object.entries(groupedData).reduce((data, [key, value]) => {
      const newKey = !isNaN(Number(key)) ? round(key, 5) : key;
      if (data[newKey]) {
        data[newKey] = data[newKey].concat(value);
      } else {
        data[newKey] = value;
      }
      return data;
    }, {});
    for (let [key, val] of Object.entries(groupedData)) {
      let sds2Items = [];
      let newItems = [];
		  let guid = [];
      let isAllValuesLinked;
      const orderUUID = uuid()
      if (isSDS2 && key !== 'undefined') {
        isAllValuesLinked = every(val, (v) => hasMfactProperty(v.attributes));
        for (let v of val) {
          if (sds2Items.length >= 50) break;
          isManufactonLinked = hasMfactProperty(v.attributes);
          if (isManufactonLinked) continue;
          const itemUUID = uuid();
          let matData = [];
          for (let m of materialData) {
            if (get(m, 'attributes.others.sds2 parent object') === v.attributes.others.allplanid) {
              const setMatName = m.type === 'MechanicalFastener' ? `${m.attributes.others.bolttype}-${round(m.attributes.others.boltdiameter)}-${round(m.attributes.others.boltlength)}-${round(get(m, 'attributes.others.bolt grip length'), 2)}${m.attributes.others.tensioncontrol ? '-TC' : ''}` : '';
              const uniqueIdentifier = matData.find((mat) => mat.identifier === setMatName);
              const uniqueIdentifier01 = matData.find((mat) => mat.identifier === get(m, 'attributes.others.material piecemark', ''));
              if (!isEmpty(uniqueIdentifier)) {
                round(uniqueIdentifier.quantity++, 4) 
                uniqueIdentifier.guids.push({guid: `E*${m.id}`})
              } else if (!isEmpty(uniqueIdentifier01)) {
                round(uniqueIdentifier01.quantity++, 4);
                uniqueIdentifier01.guids.push({guid: `E*${m.id}`});
              } else {
                matData.push({
                  name: get(m, 'attributes.others.material description', setMatName),
                  quantity: 1,
                  guids: [{
                    guid: `E*${m.id}`,
                  }],
                  identifier: get(m, 'attributes.others.material piecemark', setMatName),
                  project: selectedProject,
                  createdFrom: "SDS2",
                  category: get(m, 'attributes.others.material type', ''),
                  subCategory: get(m, 'attributes.others.steelgrade', ''),
                })
              }
            }
          }
          const sameItem = sds2Items.find((item) => item.identifier === (isNumber(get(v, 'attributes.others.piecemark', '')) ? round(get(v, 'attributes.others.piecemark', ''), 3) : get(v, 'attributes.others.piecemark', '')));
          if (!isEmpty(sameItem)) {
            round(sameItem.quantity++, 4);
            sameItem.guids.push({
              guid: `A*${v.id}`,
              quantity: 1,
              uuid: sameItem.uuid,
              objType: v.type,
            })
          } else {
            sds2Items.push({
              name: `${get(v, 'attributes.others.member description', '')}-${get(v, 'attributes.others.piecemark', '')}`,
              quantity: 1,
              uuid: itemUUID,
              guids: [{
                guid: `A*${v.id}`,
                quantity: 1,
                uuid: itemUUID,
                objType: v.type,
              }],
              purpose: 'assembly',
              materials: matData,
              identifier: isNumber(get(v, 'attributes.others.piecemark', '')) ? round(get(v, 'attributes.others.piecemark', ''), 3) : get(v, 'attributes.others.piecemark', ''),
              project: selectedProject,
              createdFrom: "SDS2",
              category: get(v, 'attributes.others.member type', ''),
              subCategory: '',
              stage: 'detailing',
            });
          }
        }
      } else if (!isSDS2 && key !== 'undefined') {
        isAllValuesLinked = every(val, (v) => hasMfactProperty(v.attributes));
        if (itemGroupingType === 'group-single') {
          if (newItems.length >= 50) {
            const itemUUID = uuid();
            for (let v of val) {
              isManufactonLinked = hasMfactProperty(v.attributes);
              if (isManufactonLinked) continue;
              v.orderUUID = orderUUID
              guid.push({
                guid: `E*${v.id}`,
                quantity: 1,
                uuid: itemUUID,
                objType: get(v, 'type', ''),
              })
            }
            newItems.push({
              name: '',
              quantity: 1,
              uuid: itemUUID,
              guids: guid,
              stage: 'detailing',
            })
          }
        } else if (itemGroupingType === 'group-Individual') {
          for (let v of val) {
            if (newItems.length >= 50) break;
            const itemUUID = uuid();
            isManufactonLinked = hasMfactProperty(v.attributes);
            if (isManufactonLinked) continue;
            v.orderUUID = orderUUID
            newItems.push({
              name: get(v, 'attributes.element.name'),
              quantity: 1,
              uuid: itemUUID,
              guids: [{
                guid: `E*${v.id}`,
                quantity: 1,
                uuid: itemUUID,
                objType: get(v, 'type', ''),
              }],
              stage: 'detailing',
            })
          }
        } else if (itemGroupingType === 'group-Assemblies') {
          let itemGroupingPath;
          itemGroupingPath = Object.keys(elementsData[0].attributes).filter((key) => {
            let itemPath = find([elementsData[0].attributes[key]], itemGroupingProperty)
            if (itemPath) return key;
          })
          const itemGroupedData = groupBy(val, `attributes.${itemGroupingPath[0]}.${itemGroupingProperty}`)
          if (!isEmpty(itemGroupedData)) {
            for (let itemDataKey in itemGroupedData) {
              if (newItems.length >= 50) break;
              const itemUUID = uuid(); 
              for (let itemData of itemGroupedData[itemDataKey]) {
                isManufactonLinked = hasMfactProperty(itemData.attributes);
                if (isManufactonLinked) continue;
                itemData.orderUUID = orderUUID;
                guid.push({
                  guid: itemDataKey === 'undefined' ? `E*${itemData.id}` : `A*${itemData.id}`,
                  quantity: 1,
                  uuid: itemUUID,
                  objType: get(itemData, 'type', ''),
                })
              }
              newItems.push({
                name: itemDataKey === 'undefined' ? 'Non-Assembly Items' : itemDataKey,
                quantity: guid.length,
                guids: guid,
                uuid: itemUUID,
                stage: 'detailing',
              })
            }
          }
        }
      }
      if (!isAllValuesLinked && key !== 'undefined') {
        creationData.push({
          name: !isNaN(Number(key)) ? round(key, 6) : key,
          stage: 'detailing',
          project: selectedProject,
          purpose: 'general',
          isCutOrder: false,
          uuid: orderUUID,
          items: isSDS2 ? sds2Items : newItems,
          todos: [],
          createdVia: 'manual',
          modelId,
          owner: owner,
        })
      }
    };
    for (let data of creationData) {
      if (!isEmpty(data.items)) {
        for (let item of data.items) {
          if (!isEmpty(item.materials)) {
            for (let material of item.materials) {
              material.quantity *= item.quantity
            }
          }
        }
      }
    }
    return { creationData: creationData, groupedData: groupedData };
  },

  async groupItems(params) {
    const { orderDetails, groupedData, itemGroupingType, itemGroupingProperty, elementsData } = params;
    let isValidUUID;
    let isAllValuesLinked;
    let isManufactonLinked;
    if (itemGroupingType === 'group-Assemblies') {
      let itemGroupingPath;
      for (let data of orderDetails) {
        let newItem = [];
        for (let [key, val] of Object.entries(groupedData)) {
          const groupingValue = () => {
            val.forEach((v) => {
              if (!isEmpty(itemGroupingPath)) return;
              itemGroupingPath = Object.keys(v.attributes).filter((key) => {
                if (_.get(v.attributes[key], itemGroupingProperty, '')) return key;
              });
            });
            return `attributes.${itemGroupingPath[0]}.${itemGroupingProperty}`;
          }
          const itemGroupedData = groupBy(val, groupingValue());
          if (!isEmpty(itemGroupedData)) {
            for (let itemDataKey in itemGroupedData) {
              isAllValuesLinked = every(itemGroupedData[itemDataKey], (k) => hasMfactProperty(k.attributes));
              const itemUUID = uuid(); 
              let newGuid = [];
              isValidUUID = some(itemGroupedData[itemDataKey], (k) => k.orderUUID === data.uuid);
              for (let itemData of itemGroupedData[itemDataKey]) {
                isManufactonLinked = hasMfactProperty(itemData.attributes);
                if (isManufactonLinked) continue;
                if (itemData.orderUUID === data.uuid) {
                  newGuid.push({
                    guid: itemDataKey === 'undefined' ? `E*${itemData.id}` : `A*${itemData.id}`,
                    quantity: 1,
                    uuid: itemUUID,
                    objType: get(itemData, 'type', ''),
                  })
                }
              }
              if (isValidUUID) {
                newItem.push({
                  name: itemDataKey === 'undefined' ? 'Non-Assembly Items' : itemDataKey,
                  quantity: newGuid.length,
                  guids: newGuid,
                  uuid: itemUUID,
                  stage: 'detailing',
                })
              }
            }
          }
        }
        if (!isAllValuesLinked) data.items = newItem;
      }
    } else if (itemGroupingType === 'group-single') {
      for (let data of orderDetails) {
        let newItem = [];
        let newGuid = [];
        const itemUUID = uuid();
        for (let [key, val] of Object.entries(groupedData)) {
          isAllValuesLinked = every(val, (v) => hasMfactProperty(v.attributes));
          for (let v of val) {
            isManufactonLinked = hasMfactProperty(v.attributes);
            if (isManufactonLinked) continue;
            if (v.orderUUID === data.uuid) {
              newGuid.push({
                guid: `E*${v.id}`,
                quantity: 1,
                uuid: itemUUID,
                objType: get(v, 'type', ''),
              })
            }
          }
        }
        newItem.push({
          name: '',
          quantity: 1,
          uuid: itemUUID,
          guids: newGuid,
          stage: 'detailing',
        })
        if (!isAllValuesLinked) data.items = newItem;
      }
    } else if (itemGroupingType === 'group-Individual') {
      for (let data of orderDetails) {
        for (let [key, val] of Object.entries(groupedData)) {
          let newItems = [];
          isAllValuesLinked = every(val, (v) => hasMfactProperty(v.attributes));
          const isValidUUID = every(val, (v) => v.orderUUID === data.uuid);
          for (let v of val) {
            isManufactonLinked = hasMfactProperty(v.attributes);
            if (isManufactonLinked) continue;
            if (isValidUUID) {
              const itemUUID = uuid();
              newItems.push({
                name: get(v, 'attributes.element.name'),
                quantity: 1,
                uuid: itemUUID,
                guids: [{
                  guid: `E*${v.id}`,
                  quantity: 1,
                  uuid: itemUUID,
                  objType: get(v, 'type', ''),
                }],
                stage: 'detailing',
              })
            }
          }
          if (isValidUUID && !isAllValuesLinked) {
            data.items = newItems;
          }
        }
      }
    }
  },

  // #endregion

  // #region Colorize Objects
  async setMfactColors(guids, color) {
    viewport3D.colorizeObjects(guids, color);
    viewport3D.draw();
  },
  resizeViewer(width, height) {
    viewport3D.setViewportSize(width, height);
  },
  redrawModel() {
    viewport3D.draw();
  },
  async getElementAttachments(guid, team_slug) {
    try {
      const accessToken = store.state.bimplus.access_token;
      if(api !== null) api.setAccessToken(accessToken);
      if(!api.getTeamSlug()) api.setTeamSlug(team_slug)
      return await api.objects.getAttachmentLinks(guid);
    } catch (error) {
      return [];
    }
  },
  // #endregion

  // #region Select Objects
  async selectObjectInViewer() {
    const selectedObjects = viewport3D.objectSets.selectedObjects;
    if(isEmpty(selectedObjects)) return;
    const selectedElem = await Promise.all(
      selectedObjects.map(obj => api.objects.get(obj.id))
    );
    return selectedElem;
  },
  async groupByItems(elementsData, groupingProperty, existingElementIds, isSDS2 = false) {
    let elementsToGroup = this.getNonMfactElements(elementsData, existingElementIds);
    const filterwithName = elementsToGroup;
    if(groupingProperty === "name" && isSDS2) {
      elementsToGroup = filterwithName.filter(item => findProperty(item, 'piecemark'));
    }
    const groupedValue = _.chain(elementsToGroup)
                            .groupBy(item => findProperty(item, groupingProperty))
                            .omit([undefined, "undefined"])
                            .value();                                                 
    return groupedValue;

  },
  getNonMfactElements(elements, existingElementIds = []) {
    return elements.filter(el => {
      const hasMfact = hasMfactProperty(el.attributes);
      const currentElementIds = existingElementIds?.includes(el.id);
      return !(hasMfact || currentElementIds);
    });
  },
  

  // #endregion
}